var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004759"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1137",
    cx: 17,
    cy: 17.5,
    r: 14.9,
    fill: "#8DA1AB",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1138",
    cx: 28.5,
    cy: 29,
    r: 7.4,
    fill: "#8DA1AB",
    stroke: "black",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/Chain.dadc4f2cfab7aaf44af92e53339401de.svg";
export { ForwardRef as ReactComponent };